import { render, staticRenderFns } from "./BaseEditableField.vue?vue&type=template&id=5044fb75&scoped=true&"
import script from "./BaseEditableField.vue?vue&type=script&lang=ts&"
export * from "./BaseEditableField.vue?vue&type=script&lang=ts&"
import style0 from "./BaseEditableField.vue?vue&type=style&index=0&id=5044fb75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5044fb75",
  null
  
)

export default component.exports